import React, { useState } from "react";
import {
  Box,
  Typography,
  Avatar,
  Grid,
  TextField,
  Button,
  Slider,
  Divider,
  Stack,
  Paper,
  ThemeProvider,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import mainTheme from "../../../newComponent/themeprovider/mainTheme/MainTheme";
import { fDate } from "../../../../utils/formatTime";
import { handleUpdateSubmittedAssignment } from "../services";
import { useSnackbar } from "../../../components/ui-component/snackbar/SnackbarContext";

const GradeAssignment = ({ rowData, onClose }) => {
    console.log("rowData", rowData);
  const userId = localStorage.getItem("userId");
  const [marks, setMarks] = useState(0);
  const [feedback, setFeedback] = useState("");
const maxLength = 1000;
const { showSnackbar } = useSnackbar();

  const handleSliderChange = (event, newValue) => {
    setMarks(newValue);
  };

  const handleFeedbackChange = (e) => {
  if (e.target.value.length <= maxLength) {
    setFeedback(e.target.value);
  }
};

const handleEditAssignment =async () => {
    if(!marks){
        showSnackbar("Please Enter Marks", "error");
        return;
    }
    if(!feedback){
        showSnackbar("Please Enter Feedback", "error");
        return;
    }
    const requestData ={
     "user_id":parseInt(userId),
    "submitted_assign_id":rowData?.id,
    "feedback":feedback,
    "obtained_marks":marks
    }
 try {
    const response = await  handleUpdateSubmittedAssignment(requestData);

    if(response.status === 200){
        showSnackbar("Assignment Updated Successfully");
        setTimeout(() => window.location.reload(), 1200);
    }

    else{
        showSnackbar(response?.message || "Update Failed", "error");
    }
    
 } catch (error) {
    console.error("Error updating assignment:", error);
    showSnackbar("Update Failed", "error");
    
 }
};


  return (
    <>
      <ThemeProvider theme={mainTheme}>
        {/* Student Info */}
        <Grid container spacing={2} alignItems="center">
          <Grid item>
            <Avatar sx={{ width: 50, height: 50 }} />
          </Grid>

          <Grid item xs>
            <Typography fontWeight={600}>{rowData?.sp_user_id?.first_name} {rowData?.sp_user_id?.last_name}</Typography>
            <Typography variant="body2" color="text.secondary">
           {rowData?.sp_user_id?.email} ({rowData?.sp_user_id?.mobile})
            </Typography>
          </Grid>

          <Grid item>
            <Typography variant="body2">
              Submitted Date : <br />
              {/* Attempt #1 */}
               Max Marks :
            </Typography>
          </Grid>

          <Grid item>
            <Typography variant="body2">
              {fDate(rowData?.submitted_date)} <br />
              {rowData?.assignment_id?.max_marks}
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        {/* Assignment Name */}
        <Typography mb={2} variant="body2">
          <b>Assignment:</b> {rowData?.assignment_id?.title} (
          {rowData?.assignment_id?.assignment_type})
        </Typography>

        {/* Submitted File */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography variant="body2">
            <b>Submitted File:</b>{" "}
            {rowData?.assignment_object?.original_filename}
          </Typography>

          <Button
            variant="contained"
            size="small"
            startIcon={<DownloadIcon />}
            onClick={()=>window.open(rowData?.assignment_link, "_blank")}
            sx={{
              backgroundColor: "#F3D9A4",
              color: "#000",
              textTransform: "none",
              "&:hover": { backgroundColor: "#e7c888" },
            }}
          >
            Download
          </Button>
        </Stack>

        {/* Feedback */}
       {/* Feedback */}
<Typography fontWeight={500} mb={1} variant="body2">
  Feedback:
</Typography>

<TextField
  multiline
  rows={4}
  fullWidth
  value={feedback}
  onChange={handleFeedbackChange}
  placeholder="Enter feedback for the student..."
  inputProps={{ maxLength: maxLength }}
/>

<Stack direction="row" justifyContent="flex-end">
  <Typography
    variant="caption"
    color={feedback.length === maxLength ? "error" : "text.secondary"}
  >
    {feedback.length} / {maxLength}
  </Typography>
</Stack>


        {/* Marks */}
        <Stack direction="row" alignItems="center" spacing={1} mt={3}>
          <Typography fontWeight={500} variant="body2">Marks</Typography>

          <TextField
            value={marks}
            size="small"
            sx={{ width: 50,   }}
            inputProps={{ readOnly: true }}
            
          />

          <Typography>out of {rowData?.assignment_id?.max_marks}</Typography>
        </Stack>

        <Slider
          value={marks}
          onChange={handleSliderChange}
          min={0}
          max={rowData?.assignment_id?.max_marks}
          valueLabelDisplay="on"
          sx={{ mt: 2 }}
        />

        {/* Footer Buttons */}
        <Stack direction="row" justifyContent="flex-end" spacing={2} mt={3}>
          <Button variant="outlined" size="small" onClick={onClose}>
            Cancel
          </Button>

          <Button
            variant="contained"
            size="small"
            color="primary"
         
            onClick={handleEditAssignment}
            sx={
              {
                // backgroundColor: "#4E8D7C",
                // textTransform: "none",
                // "&:hover": { backgroundColor: "#3b6e61" }
              }
            }
          >
            Submit Grade
          </Button>
        </Stack>
      </ThemeProvider>
    </>
  );
};

export default GradeAssignment;
